export const selectAlertsData = state => state.alerts
